import {BaseIconProps} from '@/assets/icons/types';

type ScheduleTrackerIconProps = BaseIconProps;

export const ScheduleTrackerIcon = ({
    width = '24',
    height = '24',
    viewBox = '0 0 215 238',
    className = '',
}: ScheduleTrackerIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={25}
        className={className}
    >
        <g transform="translate(0,238) scale(0.1,-0.1)">
            <path d="M480 2354 c-6 -14 -10 -76 -10 -138 l0 -113 -107 -5 c-132 -6 -192 -29 -256 -97 -87 -93 -82 -39 -82 -951 0 -769 1 -807 19 -855 25 -65 94 -137 159 -166 l52 -24 810 0 c774 0 812 1 860 19 62 24 139 95 168 155 l22 46 0 825 0 825 -27 50 c-34 65 -90 118 -153 146 -38 17 -75 24 -157 27 l-108 5 0 119 c0 66 -5 128 -10 139 -9 15 -22 19 -66 19 -49 0 -55 -2 -64 -26 -6 -14 -10 -77 -10 -140 l0 -114 -450 0 -450 0 0 121 c0 66 -5 129 -10 140 -9 15 -22 19 -66 19 -49 0 -55 -2 -64 -26z m1418 -424 c57 -35 72 -72 72 -182 l0 -98 -900 0 -900 0 0 98 c0 110 15 147 72 182 32 19 52 20 828 20 776 0 796 -1 828 -20z m70 -1064 l-3 -635 -29 -30 c-15 -16 -40 -34 -55 -40 -18 -8 -266 -11 -828 -9 l-801 3 -27 25 c-57 53 -55 28 -55 700 l0 620 900 0 900 0 -2 -634z" />
            <path d="M476 1335 c-133 -47 -190 -189 -127 -313 39 -75 107 -115 196 -116 214 0 304 268 133 397 -59 45 -133 57 -202 32z m121 -157 c26 -24 31 -73 10 -101 -6 -10 -29 -20 -49 -23 -30 -5 -41 -2 -62 19 -33 33 -33 71 -1 102 30 31 71 32 102 3z" />
            <path d="M961 1187 c-51 -26 -47 -107 5 -128 17 -6 171 -9 420 -7 432 3 417 1 430 65 5 26 1 37 -19 57 l-26 26 -393 0 c-292 0 -399 -3 -417 -13z" />
            <path d="M1535 739 c-167 -38 -216 -274 -80 -387 166 -136 405 19 355 230 -17 69 -85 139 -152 156 -53 14 -66 14 -123 1z m122 -165 c36 -49 -1 -124 -60 -124 -44 1 -67 21 -74 64 -5 30 -1 42 18 62 20 22 30 25 64 21 21 -3 45 -14 52 -23z" />
            <path d="M361 587 c-50 -25 -47 -107 4 -127 16 -6 185 -10 416 -10 l390 0 24 25 c14 13 25 36 25 50 0 14 -11 37 -25 50 l-24 25 -393 0 c-292 0 -399 -3 -417 -13z" />
        </g>
    </svg>
);
